import { api } from '@/utils/api'
import { ApiResponseHandler, Gettable } from './ApiInterfaces'
import { ApiBase, ResponseError } from './ApiBase'

/**
 * 新着お知らせ確認
 */
export namespace ApiTaNt010 {
  // API Name
  export const name: string = 'ApiTaNt010'

  // GET parameters
  export namespace Get {
    export const path: string = '/ta/newNotices'

    export interface Request {
      query: {
        courseId: string
        planId: string
      }
    }

    export interface Response {
      noticeBadgeFlg: number
      noticeNumber: number
    }
  }

  // API本体
  export class Api extends ApiBase implements Gettable<Get.Request, Get.Response, ResponseError> {
    // GET
    public get<R>(
      params: Get.Request,
      successHandler: ApiResponseHandler<Get.Response, R>,
      errorHandler: ApiResponseHandler<ResponseError, R>
    ): Promise<R | null> {
      // 成功時のレスポンス構造サンプル
      const validationSample: Get.Response = {
        noticeBadgeFlg: 0,
        noticeNumber: 0,
      }

      // エラー時のレスポンス構造サンプル
      const validationErrorSample: ResponseError = {
        error: {
          messageId: '',
          message: '',
        },
      }

      // API呼び出し
      return this.callbackWrapper<Get.Response, ResponseError, R>(
        api.get<Get.Response>(Get.path, { params: params.query }),
        successHandler,
        errorHandler,
        validationSample,
        validationErrorSample
      )
    }
  }
}
